import { ElLoading } from 'element-plus';

let loadingInstance;
let requestCount = 0;

const LoadingService = {
    start() {
        if (requestCount === 0) {
            // Element Plus 的 ElLoading.service 选项
            // 使用自定义class来创建美观的loading效果
            loadingInstance = ElLoading.service({ 
                fullscreen: true,
                customClass: 'custom-loading',
                // Avoid body width/padding jumps that can shift fixed UI.
                lock: false,
                text: '',
                background: 'rgba(255, 255, 255, 0.85)'
            });
        }
        requestCount++;
    },
    end() {
        if (requestCount <= 1) {
            // 关闭loading
            if (loadingInstance) {
                loadingInstance.close();
            }
            requestCount = 0;
        } else {
            requestCount--;
        }
    }
};

export default LoadingService;
